<template>
	<div @keydown.esc="clearFilters" class="playbooks-table__filter playbooks-filter">
		<div class="playbooks-filter__nav">
			<div class="playbooks-filter__filters">
				<div
					:class="{ selected: 'featured' === sort }"
					@click="setSort('featured')"
					class="playbooks-filter__filter playbooks-filter__filter-featured"
				>
					<span>Featured</span>
				</div>
				<div
					:class="{ selected: 'recent' === sort }"
					@click="setSort('recent')"
					class="playbooks-filter__filter playbooks-filter__filter-latest"
				>
					<span>Latest</span>
				</div>
				<div
					:class="{ active: showCategories }"
					@click="toggleCategories"
					class="playbooks-filter__filter playbooks-filter__filter-category"
				>
					<span>
						<svg-cog v-if="!showCategories" />
						<svg-close v-else />
						<span>Category Filter</span>
					</span>
				</div>
			</div>
		</div>
		<playbooks-filter-search />
		<playbooks-filter-options :active="showCategories" />
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { filtering } from '../../playbooks/mixins/filtering';
import { hasViewedPlaybooks } from '../../../utils';

export default {
	mixins: [filtering],
	data() {
		return {
			showCategories: hasViewedPlaybooks(),
		};
	},
	computed: {
		...mapState('playbooks', ['sort']),
	},
	methods: {
		/**
		 * Sets the sort in state to the current sorting value
		 *
		 * @param {string} sortBy The new sort setting
		 *
		 * @returns {void}
		 */
		setSort(sortBy) {
			this.$store.commit('playbooks/setSort', sortBy);
		},
		/**
		 * Expands and collapses the category filters
		 *
		 * @returns {void}
		 */
		toggleCategories() {
			this.showCategories = !this.showCategories;
		},
	},
};
</script>
